import React from 'react';
import ArticleHeader from '../ArticleHeader';

import * as styles from './cardArticle.module.scss';
import { navigate } from 'gatsby';
import slugify from 'slugify';

interface ICardArticleProps {
  imageUrl: string;
  title: string;
  experienceType: string;
  slug: string;
  category?: string;
}

export const CardArticle = ({
  imageUrl,
  title,
  experienceType,
  slug,
  category,
}: ICardArticleProps) => {
  const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '';

  const handleClick = () => {
    if (currentUrl.includes('experience')) {
      const url = currentUrl.split('/experience')[0];
      navigate(`${url}/experience/${slugify(slug, { lower: true })}`);
    }
  };

  return (
    <article
      className={styles.wrapper}
      onClick={handleClick}
    >
      <img
        src={imageUrl}
        alt=""
      />
      <ArticleHeader
        category={category ?? ''}
        type={experienceType}
        topBorder={false}
        // textColor={colorNav || 'black'}
      />
      <h2>{title}</h2>
    </article>
  );
};
